module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9f2c3de75374817482bce6d7ce840f78.png";